module.exports = __webpack_public_path__ + "static/img/wuxian-1.a6b7c414.png";